module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/BC4058-99270ed0db806aba38459d8988b32129.png";